/**
 * Applicant-profile link (QA d, Prompt #591, T138 (1)).
 *
 * The public profile lives at https://<config/platform.publicProfileDomain>/pro/<uid>
 * (firebase.json rewrites /pro/**). The host is never hardcoded: the old
 * hostname switch pointed prod at the dead bare apex and staging at the
 * Flutter app host (#580 item d). If the domain is missing, empty or not a
 * bare hostname, there is no link (fail closed, T83): the caller shows the
 * name as plain text.
 */
const BARE_HOSTNAME = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

export function publicProfileUrl(domain, uid) {
  if (typeof domain !== 'string' || !uid) return null;
  const host = domain.trim();
  if (!BARE_HOSTNAME.test(host)) return null;
  return `https://${host}/pro/${encodeURIComponent(uid)}`;
}
